import { render, staticRenderFns } from "./WithConfirmation.vue?vue&type=template&id=9f6f1dc8&scoped=true"
import script from "./WithConfirmation.vue?vue&type=script&lang=ts"
export * from "./WithConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./WithConfirmation.vue?vue&type=style&index=0&id=9f6f1dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6f1dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
